<template>
    <div>
        <!-- =========== GOOGLE MAP ========== -->
        <div id="map">
            <gmap-map
                    :center="center"
                    :zoom="16"
                    style="width: 100%; height: 380px"
                    :sensor="false"
            >
                <gmap-marker
                        :position="center"
                        :clickable="true"
                        :draggable="false"
                ></gmap-marker>
            </gmap-map>
        </div>

        <!-- ========== MAIN ========== -->
        <main id="contact_page">
            <div class="container">
                <div class="row">

                    <div class="col-md-8">
                        <div class="main_title a_left">
                            <h2 v-lang.contacto></h2>
                        </div>
                        <contact-form type="extend"></contact-form>
                    </div>

                    <div class="col-md-4">
                        <div class="main_title a_left">
                            <h2 v-lang.get_in_touch></h2>
                        </div>
                        <contact-info></contact-info>
                        <div class="social_media">
                            <social-item  type="facebook" ></social-item>
                            <social-item  type="twitter" ></social-item>
                            <social-item  type="googleplus" ></social-item>
                            <social-item  type="pinterest" ></social-item>
                            <social-item  type="linkedin" ></social-item>
                            <social-item  type="youtube" ></social-item>
                            <social-item  type="instagram" ></social-item>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import Form from '../../components/contactForm/Contact.vue';
    import config from '../../config/app';
    import socialItem from '../../components/subfooter/SocialItem.vue';
    import contactInfo from './contactInfo.vue';
    let lat = config.coordenate.lat, lng = config.coordenate.lng;
    export default {
        data(){
            return {
                center: {lat: config.coordenate.lat, lng: config.coordenate.lng}
            }
        },
        components : {
            'contact-form' : Form,
            'social-item' : socialItem,
            'contact-info' : contactInfo
        },
        computed : {
            address : function(){ return config.contact.address; },
            email : function(){ return config.contact.email; },
            web : function(){ return config.contact.web; },
            phone : function(){ return config.contact.phone; },
            fax : function(){ return config.contact.fax; }
        },
        created: function(){
            var self = this;
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                let latLng = val.contact.location;
                if (latLng && latLng.length && latLng.indexOf(',') !== -1) {
                    latLng = latLng.split(',');
                    if(!isNaN(latLng[0]) && !isNaN(latLng[1])){
                        lat = Number(latLng[0]);
                        lng = Number(latLng[1]);
                    }
                }
                self.center.lat = lat;
                self.center.lng = lng;
            });
        },
        mounted : function()
        {
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) )
            {
                let latLng = config.contact.location;
                if (latLng && latLng.length && latLng.indexOf(',') !== -1) {
                    latLng = latLng.split(',');
                    if(!isNaN(latLng[0]) && !isNaN(latLng[1])){
                        lat = Number(latLng[0]);
                        lng = Number(latLng[1]);
                    }
                }
                self.center.lat = lat;
                self.center.lng = lng;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Contact.vue?1349e1c4